module.exports = __webpack_public_path__ + "static/hacksaw-4f4c99294cdd9a4bedcae73f2fb8912a.svg";